export const REFERRALS_ADDITIONAL_DATA = '/api/referrals/additional-data';
export const ISSUE_REFERRAL = '/api/Referral';
export const ICD9_CODES = '/api/icd9code';
export const ICD10_CODES = '/api/icd10code';
export const getReferralsListEndpoint = (appointmentId: number) => `/api/Referral/${appointmentId}`;
export const getReferralPdfEndpoint = (referralId: string) => `/api/Referral/${referralId}/pdf`;
export const getReferralHtmlEndpoint = (referralId: string) => `/api/Referral/${referralId}/html`;